import styled from "styled-components";

export const Wrapper = styled.div`
  background: ${(props) => `url(${props.backgroundImage})`};
  //background-color: #1f2d3d;
  height: ${(props) => props?.height ?? "100vh"};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;

  z-index: ${(props) => props?.zIndex ?? 0};
  position: ${(props) => props?.position ?? "inherit"};
  border: ${(props) => props?.border ?? "none"};
  border-bottom-left-radius: ${(props) =>
    props.borderBottomLeftRadius ?? "0px"};
  border-bottom-right-radius: ${(props) =>
    props.borderBottomRightRadius ?? "0px"};
  justify-content: ${(props) => props?.justifyContent ?? "unset"};
`;

export const Container = styled.div`
  justify-content: ${(props) => props?.justifyContent ?? "inherit"};
  display: ${(props) => props?.display ?? "inherit"};
  align-items: ${(props) => props?.alignItems ?? "inherit"};
  flex-direction: ${(props) => props?.flexDirection ?? "initial"};
  //background-color: white;
  //position: relative;
  background: ${(props) =>
    `url(${props.backgroundImage}),url(${props.backgroundImage2}),url(${props.backgroundImage3})`};
  background-repeat: no-repeat;
  background-position: ${(props) => props?.backgroundPosition ?? "0 12vh"};
  background-size: cover;
  margin: ${(props) => props?.margin ?? "inherit"};
  max-width: ${(props) => props?.maxWidth ?? "unset"};
`;
